$('.slick-carousel-initialize').slick({
    nextArrow: '<button type="button" class="slick-next"><i class="far fa-angle-right" data-fa-transform="shrink-6"></i></button>',
    prevArrow: '<button type="button" class="slick-prev"><i class="far fa-angle-left" data-fa-transform="shrink-6"></i></button>',
    dots: true,
    adaptiveHeight: true,
    //lazyLoad: 'ondemand', // ondemand (default), anticipated, progressive
    infinite: true // if true, also prev slide image will be loaded (don't know why)
})

// This is a workaround to enable gradient layers with correct slide width
$('.slick-carousel-initialize').on('setPosition', function(event, slick) {
    $('.slick-slider-gradient').each(function() {
        $(this).remove();
    });
    // 'slick.listWidth' is only possible if one slide is shown, if there are multible slides shown we would need the width of each
    $('head').append('<style class="slick-slider-gradient">.slick-carousel-initialize .slide.gradient::before{width:' + slick.listWidth + 'px !important;}</style>')
})


// WEBPACK FOOTER //
// ./Private/JavaScript/Component/Carousel.js